const debugFactory = require("debug");

const DEBUG_PREFIX = "tenx:core-utils";

module.exports = function prefixedDebugFactory(name) {
  return debugFactory(`${DEBUG_PREFIX}:${name}`);
};
